import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
import { premiumCalculatePostClearData } from "../../../store/premiumCalculate/actions";
import { useDispatch } from "react-redux";
export var useErrorHandling = function (_a) {
    var errorGetCatalog = _a.errorGetCatalog, errorPerson = _a.errorPerson, errorPaymentMode = _a.errorPaymentMode, errorCalculate = _a.errorCalculate, errorComplete = _a.errorComplete, setSeeToast = _a.setSeeToast, setDisableNextButton = _a.setDisableNextButton;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    useEffect(function () {
        if (errorCalculate) {
            showErrorToast(errorCalculate, setSeeToast, t);
            setDisableNextButton === null || setDisableNextButton === void 0 ? void 0 : setDisableNextButton(true);
            dispatch(premiumCalculatePostClearData());
        }
    }, [errorCalculate]);
    useEffect(function () {
        if (errorComplete) {
            showErrorToast(errorComplete, setSeeToast, t);
        }
    }, [errorComplete]);
    useEffect(function () {
        if (errorGetCatalog) {
            showErrorToast(errorGetCatalog, setSeeToast, t);
        }
    }, [errorGetCatalog]);
    useEffect(function () {
        if (errorPerson) {
            showErrorToast(errorPerson, setSeeToast, t);
        }
    }, [errorPerson]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
};
